<template>
  <div class="clearfix ui-select"
       :class="[{ disabled: !!disabled }, color]"
       :style="{ width: computedWidth }"
       @mouseenter="resetDropdownTimer"
       @mouseleave="startDropdownTimer"
       @scroll.stop>
    <div class="item--wrap"
         :class="browser"
         :id="`selectbox${id}`">
      <p class="selected-item"
         @click.stop="toggleList">
        <span v-if="!activeItem && placeholder">
          {{ placeholder }}
        </span>
         <span :class="activeItem ? activeItem.cssClass : null"
                v-else>
          <span class="name"
                :style="{ 'max-width': `calc(100% - ${getAdditionalText(activeItem) ? getAdditionalText(activeItem).length * textSize : 0}px)` }">
            {{ getItemText(activeItem) }}
          </span>
          <span class="additional"
                v-if="getAdditionalText(activeItem)">
           {{ getAdditionalText(activeItem) }}
          </span>
        </span>
        <i class="icon">
          <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <path d="M2 5.478c0-.12.05-.242.147-.335a.54.54 0 0 1 .725-.005L8 9.85l5.128-4.712a.539.539 0 0 1 .725.005.457.457 0 0 1-.006.676L8.36 10.863a.539.539 0 0 1-.72 0L2.154 5.819A.461.461 0 0 1 2 5.48" fill-rule="evenodd" />
          </svg>
        </i>
      </p>
      <transition name="ui-selectbox-slide">
        <div v-show="showList"
             class="item__list"
             :style="{ width: computedDropWidth, maxHeight: computedMaxHeight }">
          <ul class="item__list-wrap">
            <li class="item__list-item"
                v-for="(item, index) in selectItems" :key="index"
                :class="{ on: item.value === value, 'raw-text': useRawText }"
                :title="getItemText(item)"
                @click="onChange(item.value)">
              <span class="item-name"
                    :class="[item.cssClass, {'exit': getItemText(item) === 'exit'}]"
                    :title="getItemText(item)">
                <span class="name"
                      :style="{ 'max-width': `calc(100% - ${getAdditionalText(item) ? getAdditionalText(item).length * textSize : 0}px)` }">
                  {{ getItemText(item) }}
                </span>
                <span class="additional"
                      v-if="getAdditionalText(item)">
                  {{ getAdditionalText(item) }}
                </span>
              </span>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/libs/event-bus'
import { browserInfo, isPlainObject } from '@/libs/utils'

export default {
  name: 'BaDropdown',
  props: [
    'value',
    'items',
    'width',
    'dropWidth',
    'maxHeight',
    'title',
    'disabled',
    'placeholder',
    'useRawText',
    'color',
    'isBigFontSize'
  ],
  data () {
    return {
      id: null,
      showList: false,
      dropdownTimer: null,
      dropdownTimerTime: null,
      renderedWidth: 0,
      textSize: 7
    }
  },
  computed: {
    browser () {
      return browserInfo.name
    },
    computedWidth () {
      if (!this.width && this.renderedWidth) {
        return this.renderedWidth + 'px'
      } else if (typeof this.width === 'number') {
        return this.width + 'px'
      }
      return this.width
    },
    computedDropWidth () {
      let dropWidth = '100%'
      if (typeof this.dropWidth === 'number') {
        dropWidth = this.dropWidth + 'px'
      } else if (typeof this.width === 'number') {
        dropWidth = this.width + 'px'
      } else if (!this.dropWidth && !this.width && this.renderedWidth) {
        dropWidth = this.renderedWidth + 'px'
      } else {
        dropWidth = this.dropWidth || this.width
      }
      return `calc(${dropWidth} + 2px)`
    },
    computedMaxHeight () {
      if (typeof this.maxHeight === 'number') {
        return this.maxHeight + 'px'
      }
      return this.maxHeight
    },
    selectItems () {
      return this.items.map(item => {
        if (!isPlainObject(item)) {
          return {
            value: item
          }
        }
        return item
      })
    },
    activeItem () {
      return this.selectItems.find(item => item.value === this.value)
    }
  },
  watch: {
    showList (value) {
      let bodyListener = (e) => {
        let outside = true

        function composedPath (el) {
          let paths = []
          while (el) {
            paths.push(el)
            if (el.tagName === 'HTML') {
              paths.push(document)
              paths.push(window)
              return paths
            }
            el = el.parentElement
          }
        }

        const path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target)
        if (path) {
          for (const el of path) {
            if (el.id && el.id === `selectbox${this.id}`) {
              outside = false
            }
          }
        }
        if (outside) {
          this.showList = false
        }
      }

      if (value) {
        document.body.addEventListener('click', bodyListener, false)
      } else {
        document.body.removeEventListener('click', bodyListener)
      }
    }
  },
  mounted () {
    this.id = this._uid
    if (this.isBigFontSize) {
      this.textSize = 8
    }
    this.renderedWidth = this.$el.offsetWidth
    EventBus.$on('closeAllUiSelectBox', () => {
      this.showList = false
    })
  },
  methods: {
    startDropdownTimer: function () {
      this.dropdownTimer = setInterval(() => {
        if (this.dropdownTimerTime < 3) {
          this.showList = false
        }
        this.dropdownTimerTime--
      }, 1000)
    },
    resetDropdownTimer: function () {
      this.dropdownTimerTime = 3
      clearInterval(this.dropdownTimer)
      this.dropdownTimer = null
    },
    toggleList () {
      if (this.disabled) {
        return
      }
      EventBus.$emit('closeAllUiSelectBox')
      EventBus.$emit('closeUserMenu')
      EventBus.$emit('closeDateRangePicker')
      EventBus.$emit('closeReferrerList')
      EventBus.$emit('closeJourneyPageList')
      this.$emit('click')
      this.showList = !this.showList
      if (!this.showList) {
        this.resetDropdownTimer()
      }
      this.$emit('toggle', this.showList)
    },
    onChange (value) {
      this.showList = false
      this.$emit('input', value)
      this.$emit('changed')
    },
    getItemText (item) {
      if (!item) {
        return ''
      }
      return String(item.i18n || (item.text || item.value))
    },
    getAdditionalText (item) {
      if (!item || !item.additionalText) {
        return null
      }
      return String(item.additionalText)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-select {
  position: relative;
  z-index: 2;
  cursor: pointer;
  text-align: left;
  display: inline-block;

  &.disabled {
    pointer-events: none;
    .item--wrap{
      background-color:#d7d7d7;
      opacity: 0.3;
    }
  }

  .item--wrap {
    position: relative;
    padding-left: 10px;
    display: inline-block;
    width: 100%;
    height: 32px;
    line-height: 30px;
    background-color: #ffffff;
    box-sizing: border-box;
    font-size: 13px;
    color: #666666;
    border-radius: 4px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.06);
    transition: background-color 0.3s ease;

    &.safari {
      line-height: 32px;
      transform: translateY(1px);

      .selected-item {
        .icon {
          top: calc(50% - 1px);
        }
      }
    }

    .selected-item {
      color: #2f2f2f;
      position: relative;
      height: 100%;
      transition: color 0.3s ease;

      &>span {
        display: block;
        margin-right: 35px;
      }

      .icon {
        pointer-events: none;
        position: absolute;
        top: 50%;
        right: 11px;
        transform: translateY(-50%);
        width: 16px;
        height: 20px;

        path {
          fill: #666666;
          transition: fill 0.3s ease;
        }
      }

      .name {
        max-width: 100%;
        vertical-align: middle;
        display: inline-block;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .additional {
        margin-left: 0.5ch;
        vertical-align: middle;
        display: inline-block;
      }
    }

    .item__list {
      width: calc(100% + 2px);
      position: absolute;
      top: -1px;
      left: -1px;
      background-color: #fff;
      z-index: 10000001;
      border-radius: 6px;
      box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08);
      border: 1px solid rgba(0, 0, 0, 0.25);
      transform: scaleY(1);
      opacity: 1;
      transform-origin: top;
      transition: transform 0.3s cubic-bezier(.28,.12,.42,.94),
                  opacity 0.2s ease,
                  border-color 0.3s ease,
                  background-color 0.3s ease;
      box-sizing: border-box;
      overflow: hidden;

      .item__list-wrap {
        max-height: 320px;
        overflow-y: auto;
      }

      &.ui-selectbox-slide-enter,
      &.ui-selectbox-slide-leave-to{
        transform: scaleY(0);
        opacity: 0;
      }

      .item__list-item {
        padding-left: 10px;
        height: 32px;
        color: #444;
        cursor: pointer;
        transition: color 0.3s ease,
                    background-color 0.3s ease;

        &.raw-text {
          text-transform: none;
        }

        &.on {
          background-color: #f4f4f4;
        }

        &:hover {
          background-color: #ebebeb;
        }

        .item-name {
          display: block;
          margin-right: 10px;
          white-space: nowrap;

          &.exit {
            text-transform: capitalize;
          }

          .name {
            max-width: 100%;
            vertical-align: middle;
            display: inline-block;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          .additional {
            margin-left: 0.5ch;
            vertical-align: middle;
            display: inline-block;
          }
        }
      }
    }
  }

  // animation off

  .item--wrap {
    transition: none !important;

    .selected-item {
      transition: none !important;

      .icon {
        path {
          transition: none !important;
        }
      }
    }
  }

  .item__list {
    transition: transform 0.3s cubic-bezier(.28,.12,.42,.94),
                opacity 0.2s ease !important;

    .item__list-item {
      transition: none !important;
    }
  }

  // animation off - end

  &.dark {
    .item--wrap {
      background-color: #555555;

      .selected-item {
        color: #ffffff;

        .icon {
          path {
            fill: #ffffff;
          }
        }
      }
    }

    .item__list {
      border-color: rgba(255, 255, 255, 0.25);
      background-color: #333333;

      .item__list-item {
        color: #ffffff;
        cursor: pointer;

        &.raw-text {
          text-transform: none;
        }

        &.on {
          background-color: #1b1b1b;
        }

        &:hover {
          background-color: #444444;
        }
      }
    }
  }
}
</style>
